'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140 from "./presto.types$-U-R-L$$anon$140.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141 from "./presto.types$-U-R-L$$anon$141.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142 from "./presto.types$-U-R-L$$anon$142.js";
var $p;
/** @constructor */
function $c_Lpresto_types$URL$() {
  this.cdk = null;
  this.cdl = false;
  this.cdi = null;
  this.cdj = false;
  this.cdm = null;
  this.cdn = false;
  this.cdo = null;
  this.cdp = false;
  this.cdg = null;
  this.cdh = false;
  this.cde = null;
  this.cdf = false;
}
export { $c_Lpresto_types$URL$ as $c_Lpresto_types$URL$ };
$p = $c_Lpresto_types$URL$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$URL$;
/** @constructor */
function $h_Lpresto_types$URL$() {
}
export { $h_Lpresto_types$URL$ as $h_Lpresto_types$URL$ };
$h_Lpresto_types$URL$.prototype = $p;
$p.p9 = (function() {
  if ((!this.cdl)) {
    this.cdk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cdl = true;
  }
  return this.cdk;
});
$p.fd = (function() {
  if ((!this.cdj)) {
    this.cdi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.cdj = true;
  }
  return this.cdi;
});
$p.GJ = (function() {
  if ((!this.cdn)) {
    this.cdm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cdn = true;
  }
  return this.cdm;
});
$p.csB = (function() {
  if ((!this.cdp)) {
    this.cdo = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140.$c_Lpresto_types$URL$$anon$140(this);
    this.cdp = true;
  }
  return this.cdo;
});
$p.cs2 = (function() {
  if ((!this.cdh)) {
    this.cdg = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141.$c_Lpresto_types$URL$$anon$141(this);
    this.cdh = true;
  }
  return this.cdg;
});
$p.cHJ = (function() {
  if ((!this.cdf)) {
    this.cde = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142.$c_Lpresto_types$URL$$anon$142(this);
    this.cdf = true;
  }
  return this.cde;
});
var $d_Lpresto_types$URL$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$URL$, "presto.types$URL$", ({
  a2x: 1,
  D: 1
}));
export { $d_Lpresto_types$URL$ as $d_Lpresto_types$URL$ };
var $n_Lpresto_types$URL$;
function $m_Lpresto_types$URL$() {
  if ((!$n_Lpresto_types$URL$)) {
    $n_Lpresto_types$URL$ = new $c_Lpresto_types$URL$();
  }
  return $n_Lpresto_types$URL$;
}
export { $m_Lpresto_types$URL$ as $m_Lpresto_types$URL$ };
//# sourceMappingURL=presto.types$-U-R-L$.js.map
